"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _getExistingReleaseBranch = _interopRequireDefault(require("../release/getExistingReleaseBranch"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-console */
function _default(execSync, prompt) {
  execSync('git fetch -p', {
    stdio: 'inherit'
  });
  var branchToMerge;

  try {
    branchToMerge = (0, _getExistingReleaseBranch.default)(execSync, prompt);
  } catch (e) {
    console.log('There is no release/hotfix branch to merge!');
    process.exit(1);
  }

  var semver;

  try {
    /* eslint-disable-next-line prefer-destructuring */
    semver = branchToMerge.match(/\d+\.\d+\.\d+/)[0];
  } catch (e) {
    console.log('Invalid release number. Please proceed manually.');
    process.exit(1);
  }

  var answer = prompt("\n  Gearing up to merge n tag \"".concat(branchToMerge, "\". Ok to proceed?\n\n  Type 'yes' or 'no': "));

  if (answer !== 'yes') {
    console.log('Quitting! Come back when you\'re ready!');
    process.exit(1);
  }

  console.log("Merging \"".concat(branchToMerge, "\" into develop..."));
  execSync('git checkout develop');
  execSync('git pull');
  execSync("git merge --no-ff origin/".concat(branchToMerge));
  execSync('git push origin develop');
  console.log('...done!');
  console.log("Merging \"".concat(branchToMerge, "\" into master..."));
  execSync('git checkout master');
  execSync('git pull');
  execSync("git merge --no-ff origin/".concat(branchToMerge));
  execSync('git push origin master');
  console.log('...done!');
  console.log("Creating tag \"".concat(semver, "\"..."));
  execSync("git tag ".concat(semver));
  execSync("git push origin ".concat(semver));
  console.log('...done!');
  console.log("Killing \"".concat(branchToMerge, "\"..."));
  execSync("git push origin :".concat(branchToMerge));
  console.log('...killed X-o');
  console.log('Consider yourself merged \'n tagged');
}